import { render, staticRenderFns } from "./AddExpenses.vue?vue&type=template&id=d0fcf126&scoped=true&"
import script from "./AddExpenses.vue?vue&type=script&lang=js&"
export * from "./AddExpenses.vue?vue&type=script&lang=js&"
import style0 from "./AddExpenses.vue?vue&type=style&index=0&id=d0fcf126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fcf126",
  null
  
)

export default component.exports